// actions
import { AUTOCOMPLETE_UPDATE_INPUT } from './actions';

const Autocomplete = (state = {
  input: '',
}, action) => {
  switch (action.type) {
    case AUTOCOMPLETE_UPDATE_INPUT:
      return {
        ...state,
        input: action.input,
      };
    default:
      return state;
  }
};

export default Autocomplete;
